import React from 'react';
import { Star } from 'lucide-react';
import { User } from '../types';
interface TopPicksProps {
  profiles: User[];
}
export function TopPicks({
  profiles
}: TopPicksProps) {
  const topPicks = profiles.slice(0, 4);
  return <div className="mb-8" data-id="element-525">
      <div className="flex items-center gap-2 px-2 mb-4" data-id="element-526">
        <Star size={18} className="text-amber-500 fill-amber-500" data-id="element-527" />
        <h2 className="text-lg font-bold text-zinc-900" data-id="element-528">Top Picks</h2>
        <span className="px-2 py-0.5 bg-amber-100 text-amber-600 text-[10px] font-bold rounded-full uppercase tracking-wide" data-id="element-529">
          Gold
        </span>
      </div>

      <div className="flex gap-3 overflow-x-auto pb-4 px-2 -mx-2 scrollbar-hide" data-id="element-530">
        {topPicks.map(profile => <div key={profile.id} className="relative flex-shrink-0 w-32 aspect-[3/4] rounded-xl overflow-hidden group" data-id="element-531">
            <img src={profile.photos[0]} alt={profile.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-532" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-533" />

            <div className="absolute bottom-2 left-2 right-2" data-id="element-534">
              <h3 className="text-white font-bold text-sm truncate" data-id="element-535">
                {profile.name}
              </h3>
              <p className="text-white/80 text-xs truncate" data-id="element-536">
                {profile.age} • {profile.job}
              </p>
            </div>

            <div className="absolute top-2 right-2 px-1.5 py-0.5 bg-amber-500 text-white text-[10px] font-bold rounded shadow-sm" data-id="element-537">
              TOP
            </div>
          </div>)}
      </div>
    </div>;
}